import { OrderOption } from "PFTypes";

export const ORDER_OPTIONS_WITH_CALENDAR_RANGE = ["billable_utilization", "available_minutes"];

export const getOrderId = (option: OrderOption | undefined): string =>
  `${option?.name?.[0]}_${option?.direction}`;
